"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.todayInNj = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
dayjs_1.default.extend(utc_1.default);
function todayInNj() {
    return (0, dayjs_1.default)().subtract(5, 'hour').utc().format('YYYY-MM-DD');
}
exports.todayInNj = todayInNj;
//# sourceMappingURL=todayInNj.js.map